import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PopinContainerComponent } from '@shared/components/popin-container';
import { SafeResourceUrlPipe } from '@shared/pipe';

interface VirtualTourDialogData {
  url: string;
}

@Component({
  selector: 'app-virtual-tour-dialog',
  standalone: true,
  imports: [PopinContainerComponent, SafeResourceUrlPipe],
  template: `
    <app-popin-container bgColor="GRAY" [hasPadding]="false">
      @if (data.url; as url) {
        <iframe class="absolute inset-0 w-full h-full" [src]="url | safeResourceUrl"></iframe>
      }
    </app-popin-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VirtualTourDialogComponent {
  protected readonly data = inject<VirtualTourDialogData>(DIALOG_DATA);
}
